import "./style.scss";

class AirshipNotificationBanner extends HTMLElement {
	constructor() {
		super();

		this.isVisible = false;

		this.$wrap = null;
		this.$text = null;
		this.$buttons = null;
		this.$optIn = null;
		this.$optOut = null;

		this.optIn = this.optIn.bind(this);
		this.optOut = this.optOut.bind(this);
		this.render = this.render.bind(this);
		this.setupEls = this.setupEls.bind(this);

		this.setupEls();
	}

	static get observedAttributes() {
		return ["opt-in-label", "opt-out-label", "text"];
	}

	attributeChangedCallback(attributeName, oldValue, newValue) {
		this[attributeName] = newValue;

		if (attributeName === "opt-in-label") {
			this.optInLabel = newValue;
			this.$optIn.innerHTML = newValue;
		} else if (attributeName === "opt-out-label") {
			this.optOutLabel = newValue;
			this.$optOut.innerHTML = newValue;
		} else if (attributeName === "text") {
			this.text = newValue;
			this.$text.innerHTML = newValue;
		} else {
			this[attributeName] = newValue;
		}

		this.render();
	}

	connectedCallback() {
		this.render();

		setTimeout(() => {
			this.isVisible = true;
			this.render();
		}, 500);
	}

	disconnectedCallback() {}

	optIn() {
		window.dispatchEvent(
			new CustomEvent("airship-notifications-soft-ask-opt-in", {
				bubbles: true,
				detail: {},
			})
		);

		this.isVisible = false;
		this.render();
	}

	optOut() {
		window.dispatchEvent(
			new CustomEvent("airship-notifications-soft-ask-dismiss", {
				bubbles: true,
				detail: {},
			})
		);

		this.isVisible = false;
		this.render();
	}

	render() {
		this.innerHTML = "";
		this.classList.add("airship-notification-banner");
		this.classList.toggle("is-visible", this.isVisible);
		this.appendChild(this.$wrap);

		document.body.classList.toggle(
			"has-notification-banner",
			this.isVisible
		);
	}

	setupEls() {
		if (this.$wrap === null) {
			this.$wrap = document.createElement("div");
			this.$wrap.classList.add("airship-notification-banner__wrap");
		}

		if (this.$text === null) {
			this.$text = document.createElement("div");
			this.$text.classList.add("airship-notification-banner__text");
			this.$text.innerHTML = this.text;
			this.$wrap.appendChild(this.$text);
		}

		if (this.$buttons === null) {
			this.$buttons = document.createElement("div");
			this.$buttons.classList.add("airship-notification-banner__buttons");
			this.$wrap.appendChild(this.$buttons);
		}

		if (this.$optIn === null) {
			this.$optIn = document.createElement("a");
			this.$optIn.setAttribute(
				"data-event",
				"web-notification | accepted"
			);
			this.$optIn.classList.add("airship-notification-banner__button");
			this.$optIn.classList.add("is-primary");
			this.$optIn.innerHTML = this.optInLabel;
			this.$optIn.addEventListener("click", this.optIn);
			this.$buttons.appendChild(this.$optIn);
		}

		if (this.$optOut === null) {
			this.$optOut = document.createElement("a");
			this.$optOut.setAttribute(
				"data-event",
				"web-notification | dismissed"
			);
			this.$optOut.classList.add("airship-notification-banner__button");
			this.$optOut.innerHTML = this.optOutLabel;
			this.$optOut.addEventListener("click", this.optOut);
			this.$buttons.appendChild(this.$optOut);
		}
	}
}

customElements.define("airship-notification-banner", AirshipNotificationBanner);
